var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"red","font-style":"italic","font-size":"0.9rem"}},[_vm._v(" "+_vm._s(_vm.$t("info-panels.local-data-only"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }